<template>
  <div class="fill">
    <hydro-map
            @basin-click="basinClick"
            @show-hint="showMessage"
            @view-basin-data="showBasinData = true"
            :geojsons="geojsons"
            :attrs="attrs">
    </hydro-map>

    <v-snackbar top right :value="showSnackbar"><v-icon color="white">notifications_none</v-icon><h4>{{ message }}</h4></v-snackbar>
    <v-bottom-sheet v-model="showBasinData">
      <basin
              :id="basinID"
              :watershed="watershed"
              :allBasinData="attrs"
              @close-basin-data="showBasinData = false"
              @show-hint="showMessage">
      </basin>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import Basin from '@/components/Basin';
  import HydroMap from '@/components/HydroMap'

  export default {
    name: "Hydro",

    components: {
      Basin,
      HydroMap
    },

    beforeMount () {
      this.loadData()
    },

    data () {
      return {
        message: null,
        showBasinData: false,
        attrs: [],
        geojsons: [],
        watershed: '',
        basinID: -1,
        showSnackbar: false
      }
    },

    methods: {
      showMessage (message) {
        this.message = message;
        this.showSnackbar = true;
        setTimeout(() => this.showSnackbar = false, 6000)
      },

      loadData () {
        this.$Config.watersheds.forEach(ws => {
          this.$API.get('mapApi', `/${ws}_basins_data.json`, {})
            .then(response => {
              this.attrs.push({
                name: ws,
                data: response
              })
            });
          this.$API.get('mapApi', `/${ws}_basins.geojson`, {})
            .then(response => {
              this.geojsons.push({
                name: ws,
                data: response
              })
            })
        })
      },

      basinClick (id, ws) {
        this.basinID = id;
        this.watershed = ws
      }
    }

  }
</script>

<style scoped>
  .fill {
    padding: 0;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .text-center {
    text-align: center;
    margin-left: 20%
  }
  .hydro-nav {
    max-height: 100px;
  }
</style>
